/**
 * Oppretter og legger til et modul-script i dokumentets `<head>`.
 * @param src URL til script-filen som skal lastes.
 */
export const appendScript = (src) => {
    const scriptElement = document.createElement('script');
    scriptElement.setAttribute('src', src);
    scriptElement.setAttribute('type', 'module');
    document.head.appendChild(scriptElement);
};
/**
 * Oppretter og legger til et stylesheet i en `<template>`
 * @param href URL til stylesheet som skal legges til
 * @param templateElement `<template>`-en som skal få stylesheet. Hvis den ikke er satt, gjøres ingenting.
 */
export const appendStylesheet = (href, templateElement) => {
    const cssElement = document.createElement('link');
    cssElement.setAttribute('href', href);
    cssElement.rel = 'stylesheet';
    if (templateElement) {
        templateElement.content.appendChild(cssElement);
    }
};
/**
 * Returnerer en Promise som resolves første gang et gitt event fyres på target.
 * Lytteren fjernes etter første fyring av event.
 * @param target EventTarget som det lyttes på.
 * @param event Navn på eventet det lyttes etter.
 * @returns Promise som resolves når eventet fyres på target.
 */
export const blockUntilEvent = (target, event) => {
    return new Promise(resolve => target.addEventListener(event, resolve, { passive: true, once: true }));
};
/**
 * Oppretter et <template>-element med gitt id og legger det til i dokumentets `<head>`.
 * @param templateName ID som settes på `<template>`-elementet.
 * @returns Det opprettede `<template>`-elementet.
 */
export const createMicrowebTemplate = (templateName) => {
    const templateElement = document.createElement('template');
    templateElement.setAttribute('id', templateName);
    document.head.appendChild(templateElement);
    return templateElement;
};
/**
 * Sjekker om det er registrert custom element allerede er registrert i nettleseren.
 * @param name
 * @returns
 */
export const isCustomElementRegistered = (name) => {
    return !!window.customElements.get(name);
};
